import BaseStore from '@/store/baseStore'
import { generateSingleItemOverview } from '@/store/baseOverview'

export const namespaced = true

const baseURI = '/stab_schematisation_stage/'

const baseStore = new BaseStore(baseURI)
const baseOverview = generateSingleItemOverview({})

const getDefaultState = () => {
  return {
    ...baseStore.state,
    status: 'empty',
    model: {},
    currentItem: null
  }
}
export const state = {
  ...getDefaultState(),
  ...baseOverview.state
}

export const mutations = {
  ...baseStore.mutations,
  ...baseOverview.mutations,
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}
export const actions = {
  ...baseStore.actions,
  ...baseOverview.actions,
  resetState(context) {
    context.commit('resetState')
  }
}

export const getters = {
  isLockedHeadLine2: (state) => {
    return !state.currentItem || state.currentItem.stage_configuration.head_line_2 === 'no'
  },
  currentCompositionId: (state) => {
    return state.currentItem ? state.currentItem.soilcomposition : null
  },
  currentTopoProfileId: (state) => {
    return state.currentItem ? state.currentItem.topoprofile : null
  },
  currentSoilTypeRevisionId: (state) => {
    return state.currentItem ? state.currentItem.soiltyperevision : null
  },
  getStabSchematisationStageById: (state) => (stabSchematisationStageId) => {
    return state.itemsOverview.find((stage) => stage.id === stabSchematisationStageId)
  },
  getLoadingById: baseOverview.getters.getLoadingById,
  currentStabSchematisationStageId: (state) => {
    return state.currentItem ? state.currentItem.id : null
  },
  getSchematisationStageToImport: (state) => (path) => {
    const availableIds = state.currentItem?.[path]
    return state.items.filter((stage) => availableIds.includes(stage.id))
  },
  previousSchematisationStagesHaveTopoProfile: (state, getters) => {
    return getters.getSchematisationStageToImport(
      'previous_schematisation_stages_have_topo_profile'
    )
  },
  previousSchematisationStagesHaveSoilProfile: (state, getters) => {
    return getters.getSchematisationStageToImport(
      'previous_schematisation_stages_have_topo_profile'
    )
  },
  previousSchematisationStagesHaveReinforcement: (state, getters) => {
    return getters.getSchematisationStageToImport(
      'previous_schematisation_stages_have_reinforcement'
    )
  },
  previousSchematisationStagesHavePhreaticLine: (state, getters) => {
    return getters.getSchematisationStageToImport(
      'previous_schematisation_stages_have_phreatic_line'
    )
  },
  previousSchematisationStagesHaveLoad: (state, getters) => {
    return getters.getSchematisationStageToImport('previous_schematisation_stages_have_loads')
  },
  previousSchematisationStagesHaveHeadLine: (state, getters) => {
    return getters.getSchematisationStageToImport('previous_schematisation_stages_have_head_line')
  }
}
